module.exports = __webpack_public_path__ + "img/2019112005.2aa726ed.jpg";